import { BaseService } from '../base.service'

export class DocumentService extends BaseService {

	public reset(tpl_id: string): Promise<any> {
		return super.put(`/reset/document/${tpl_id}`)
	}
}
